import { render } from "./AsideGroupList.vue?vue&type=template&id=f1174d5c&scoped=true"
import script from "./AsideGroupList.vue?vue&type=script&lang=js"
export * from "./AsideGroupList.vue?vue&type=script&lang=js"

import "./AsideGroupList.vue?vue&type=style&index=0&id=f1174d5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1174d5c"]])

export default __exports__